import { c as _c } from "react/compiler-runtime";
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import CourseSelect from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-course-item/components/course-select';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { TriggerCourseEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import React from 'react';
export interface TriggerCourseItemProps extends EditTriggerItemInterface<TriggerCourseEditInterface> {}
const TriggerCourseItem = t0 => {
  const $ = _c(15);
  const {
    trigger,
    triggers,
    idx,
    errors,
    setRules,
    onDelete,
    isStatic
  } = t0;
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== trigger.course || $[8] !== trigger.id || $[9] !== triggers) {
    t2 = t3 => {
      const {
        data,
        renderTriggerLabel,
        onOpen
      } = t3;
      return <><CourseSelect isStatic={isStatic} courseId={trigger.course.id} triggerId={trigger.id} courseData={data.courseData} course={trigger.course} errors={errors} renderTriggerLabel={renderTriggerLabel} onOpen={onOpen} onChange={data_0 => setRules(prev => ({
          ...prev,
          triggers: triggers.map((el, i) => {
            if (idx === i) {
              return {
                ...el,
                course: {
                  id: data_0
                }
              };
            } else {
              return el;
            }
          })
        }))} /></>;
    };
    $[3] = errors;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = trigger.course;
    $[8] = trigger.id;
    $[9] = triggers;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[11] = t1;
    $[12] = t2;
    $[13] = trigger;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default TriggerCourseItem;